import RequestUtils from "utils/RequestUtils";

import CreateClientRes from "types/res/payment/CreateClientRes";
import { PlanType } from "types/enum/PlanType";

export default class PaymentApi {
  private constructor() {}

  static async findOrCreateSubscription(
    companyId: number,
    priceId: string,
    isAnnual: boolean
  ): Promise<CreateClientRes> {
    return await RequestUtils.post(
      CreateClientRes,
      `/payment/findOrCreateSubscription/${companyId}/${priceId}`,
      { isAnnual }
    );
  }

  static async findOrCreateSubscriptionOnMail(
    companyId: number,
    priceId: string,
    isAnnual: boolean,
    planType: PlanType
  ) {
    return await RequestUtils.postVoid(
      `/payment/findOrCreateSubscriptionOnMail/${companyId}/${priceId}`,
      { isAnnual, planType }
    );
  }

  static async updatePaymentMethod(companyId: number, paymentMethodId: string) {
    return await RequestUtils.postVoid(
      `/payment/updatePaymentMethod/${companyId}/${paymentMethodId}`,
      {}
    );
  }

  static async createSetupIntent(
    companyId: number
  ): Promise<{ clientSecret: string }> {
    return await RequestUtils.postPlain(
      `/payment/createSetupIntent/${companyId}`,
      {}
    );
  }

  /**
   * ★止まっているか と 払う先★（2026-08-13・代表 判断 甲）
   *
   * この画面に 在る 手は「このプランにする」「カード欄」「無料へ 変更」の 3 つで、
   * ★どれも「既に 立っている 未払いの 請求書を 払う」手では 無い★。
   * 止まっている 理由は その 請求書なので、プランを 選び直しても 残る。
   * ⇒ サーバが 返す 請求書の 頁（Stripe・ログイン不要）へ 直に 行けるように する。
   *
   * 増やしただけ で 既存の 3 つは そのまま（消す/形を 変えるは しない）。
   */
  static async getStatus(
    companyId: number
  ): Promise<{
    hasPaymentMethod: boolean;
    trialEnd: string | null;
    willEnd: boolean;
    cancelAt: string | null;
    suspended?: boolean;
    hostedInvoiceUrl?: string | null;
    amountDueJpy?: number | null;
  }> {
    return await RequestUtils.postPlain(`/payment/status/${companyId}`, {});
  }

  static async cancelSubscription(companyId: number) {
    return await RequestUtils.postVoid(
      `/payment/cancelSubscription/${companyId}`,
      {}
    );
  }

  static async uncancelSubscription(companyId: number) {
    return await RequestUtils.postVoid(
      `/payment/uncancelSubscription/${companyId}`,
      {}
    );
  }
}
